import { useEffect, useRef } from "react";
import { isTyping, matches } from "./keys";

export interface Binding { keys: string; run: (e: KeyboardEvent) => void; whileTyping?: boolean }

// Global shortcuts for as long as the component is on screen. Plain keys don't fire while typing in a field unless the
// binding says so; Alt / Ctrl combinations and function keys always do.
export function useShortcuts(bindings: Binding[]) {
  const ref = useRef(bindings);
  ref.current = bindings;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.defaultPrevented) return;          // a field or form already handled it
      const typing = isTyping(e.target);
      for (const b of ref.current) {
        if (!matches(e, b.keys, e.code)) continue;
        const combo = /alt|ctrl|cmd|^f\d+$/i.test(b.keys) || /\+f\d+$/i.test(b.keys);
        if (typing && !combo && !b.whileTyping) continue;
        e.preventDefault();
        b.run(e);
        return;
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
}
